import { ContainerId, PlacementId } from '@schibsted-nmp/advertising-companion';
import React from 'react';

type AdvertisingPlacementProps = {
    className?: string;
};

export function AdvertisingPlacementTop2(props: AdvertisingPlacementProps) {
    const { className } = props;

    return (
        <AdvertisingWrapper
            className={className}
            containerId={ContainerId.Top2}
            placementId={PlacementId.Top2}
        />
    );
}

export function AdvertisingPlacementBottom1(props: AdvertisingPlacementProps) {
    const { className } = props;

    return (
        <AdvertisingWrapper
            className={className}
            containerId={ContainerId.Bottom1}
            placementId={PlacementId.Bottom1}
        />
    );
}

type AdvertisingWrapperProps = {
    className?: string;
    containerId: ContainerId;
    placementId: PlacementId;
    style?: React.CSSProperties;
};

export function AdvertisingWrapper(props: AdvertisingWrapperProps) {
    const { className, containerId, placementId, style } = props;

    return (
        <div
            className={className}
            style={style}
            // Ignore hydration warning because advt-component adds a slotted
            // element to the light DOM. This elements causes React to complain
            // about mismatching DOM structures between the server and the client.
            suppressHydrationWarning
        >
            {/* @ts-expect-error Property 'class' does not exist on type '{ containerId?: string | undefined; placementId: string; adIndex?: number | undefined; cols?: 1 | 2 | 3 | undefined; additionalData?: object | undefined; key?: string | undefined; children?: any; }'.ts(2322) */}
            <advt-component class="w-fit" placementId={placementId}>
                <div id={containerId} slot={`${placementId}--slot`}></div>
                {/* @ts-expect-error Property 'class' does not exist on type '{ containerId?: string | undefined; placementId: string; adIndex?: number | undefined; cols?: 1 | 2 | 3 | undefined; additionalData?: object | undefined; key?: string | undefined; children?: any; }'.ts(2322) */}
            </advt-component>
        </div>
    );
}
